
































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_unidad_medidas from '@/mixins/axios/indicador_unidad_medidas'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
             
            
          
            {
                tag:'unidad_medida',
                data:'unidad_medida',
                active:true
            },
           
               {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
            
           
        ],




        id:null as any,

      unidad_medida:'' as any,
     
     
         
         
              indicador_umdata:[] as any,
      
    }
  },
     mixins: [indicador_unidad_medidas],
     validations: {
    
           unidad_medida: {
      required,
    },
 
     

   
  },
  methods:{
       
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_UNIDAD_MEDIDAS(row).then(response => {

                    if (response != null) {

 this.indicador_umdata=this.indicador_umdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.unidad_medida=null;

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_unidad_medidas').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.unidad_medida=row.unidad_medida;

            
          
 $('#ac_modal_indicador_unidad_medidas').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_UNIDAD_MEDIDAS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_umdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Unidad Medidas, refresque la pagina");

                    }    $("#ac_modal_indicador_unidad_medidas").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_INDICADOR_UNIDAD_MEDIDAS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador Unidad Medida modificado exitosamente, refresque la pagina");
  this.indicador_umdata=this.indicador_umdata.filter(item => item.id !== dat.id);
 this.indicador_umdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Indicador Unidad Medidas, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
           unidad_medida:this.unidad_medida,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_UNIDAD_MEDIDAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_umdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

